import BuiltSmartLogo from '../../images/BuiltSmartLogo.svg';
import BuiltSmartSlide01 from '../../images/HouseSmartVideoBuiltSmart.jpg';
import BuiltSmartSlide02 from '../../images/house-smart-slides/BuiltSmartSlide02.jpg';
import BuiltSmartSlide03 from '../../images/house-smart-slides/BuiltSmartSlide03.jpg';
import BuiltSmartSlide04 from '../../images/house-smart-slides/BuiltSmartSlide04.jpg';
import BuiltSmartSlide05 from '../../images/house-smart-slides/BuiltSmartSlide05.jpg';

import DesignSmartLogo from '../../images/DesignSmartLogo.svg';
import DesignSmartSlide01 from '../../images/HouseSmartVideoDesignSmart.jpg';
import DesignSmartSlide02 from '../../images/house-smart-slides/DesignSmartSlide02.jpg';
import DesignSmartSlide03 from '../../images/house-smart-slides/DesignSmartSlide03.jpg';
import DesignSmartSlide04 from '../../images/house-smart-slides/DesignSmartSlide04.jpg';
import DesignSmartSlide05 from '../../images/house-smart-slides/DesignSmartSlide05.jpg';

import EnergySmartLogo from '../../images/EnergySmartLogo.svg';
import EnergySmartSlide01 from '../../images/HouseSmartVideoEnergySmart.jpg';
import EnergySmartSlide02 from '../../images/house-smart-slides/EnergySmartSlide02.jpg';
import EnergySmartSlide03 from '../../images/house-smart-slides/EnergySmartSlide03.jpg';
import EnergySmartSlide04 from '../../images/house-smart-slides/EnergySmartSlide04.jpg';
import EnergySmartSlide05 from '../../images/house-smart-slides/EnergySmartSlide05.jpg';

import BudgetSmartLogo from '../../images/BudgetSmartLogo.svg';
import BudgetSmartSlide01 from '../../images/HouseSmartVideoBudgetSmart.jpg';
import BudgetSmartSlide02 from '../../images/house-smart-slides/BudgetSmartSlide02.jpg';
import BudgetSmartSlide03 from '../../images/house-smart-slides/BudgetSmartSlide03.jpg';
import BudgetSmartSlide04 from '../../images/house-smart-slides/BudgetSmartSlide04.jpg';

const houseSmartPillarContent = [
  {
    headline: 'Built to last a lifetime.',
    color: '#E83F52',
    logo: BuiltSmartLogo,
    id: 'BuiltSmart',
    slides: [
      {
        image: BuiltSmartSlide01,
        videoID: 'q9bx17t9fh',
        fobVideoID: '3lh5wwl1ck',
        gaClass: 'ga-housesmart-video-builtsmart',
        retailEventLabel: 'housesmart_builtsmart_video',
        content: `<p class="h3">Over the last 60 years we’ve done more than build homes, we’ve transformed how they’re built in the first place.</p>`,
      },
      {
        image: BuiltSmartSlide05,
        content: `<p class="h3">Building A Better Tomorrow</p><p>Sustainable practices help us minimize our impact on the plant.</p><ul><li>We commit to plant two trees for every one used in the construction of our homes, restoring over 2 million trees to the environment this year.*</li><li>Exact measurements reduce production waste and we further improve efficiency by diverting over 10,000 tons of waste from landfills every year through recycling and material re-use efforts.</li></ul><p class="footnote">*Based on two trees planted by the Arbor Day Foundation for every estimated tree used in our home building process in the previous year; assuming estimated board feet used at 754 board feet per tree and average square footage of our homes built by type.</p>`,
      },
      {
        image: BuiltSmartSlide02,
        content: `<p class="h3">Quality Brands and Products</p><p>A building process is only as good as what goes into it. For us, that means quality products from the industry’s most trusted brands, so your home is built to last.</p><div class="scroll-to-partners">View All Partners</div>`,
      },
      {
        image: BuiltSmartSlide03,
        content: `<p class="h3">A Strong Foundation</p><p>Our pier and beam foundations use massive anchors driven deep into the ground to secure your home against the elements, and we have crawl space, slab or basement options to suit any need.</p><p>2” x 6” floor joists on 16” centers means we use 48% more joists in our average home*, which combined with our interlocking floor decking ensures a solid sub-floor.</p><p class="footnote">*Compared to 24” center floor joists in a 56’ multi-section home.</p>`,
      },
      {
        image: BuiltSmartSlide04,
        content: `<p class="h3">Exterior Walls</p><p>Keep your world cozy, comfortable & secure with 2” x 4” studs on 16” centers that are packed with R11 insulation to help with energy efficiency while ThermoPly structural sheathing provides durability, moisture resistance and a best in class air barrier.</p>`,
      },
    ],
  },
  {
    headline: 'Homes for every lifestyle.',
    color: '#352269',
    logo: DesignSmartLogo,
    id: 'DesignSmart',
    slides: [
      {
        image: DesignSmartSlide01,
        videoID: '00tw9xdd8q',
        fobVideoID: 'rvtyrbqfnj',
        gaClass: 'ga-housesmart-video-designsmart',
        retailEventLabel: 'housesmart_designsmart_video',
        content: `<p class="h3">The construction of your home is important, but it's the finishing touches that take your house to a dream home. Visit us today to explore ways to personalize your new home!</p>`,
      },
      {
        image: DesignSmartSlide02,
        content: `<p class="h3">In the Details</p><p>Homes are designed with you in mind. With features like open floor plans, flex spaces, built-in media centers, smart storage solutions and primary bedrooms with walk-in closets and spa bathrooms -- you’ll find a floor plan that compliments your lifestyle at any budget.</p>`,
      },
      {
        image: DesignSmartSlide03,
        content: `<p class="h3">Designer Kitchens</p><p>Products from the industry’s best brands will make your new kitchen a joy to be in and a breeze to cook in. Stainless steel Samsung® and Frigidaire® appliances and tough DuraCraft ® cabinets add up to a dependable place to prepare meals for years to come.</p>`,
      },
      {
        image: DesignSmartSlide04,
        content: `<p class="h3">Curb Appeal</p><p>With endless colors and siding options, such as Variform by Plygem vinyl siding, LP® SmartSide, James Hardie Cemplank® and fiberglass or architectural shingles, DesignSmart has you covered inside and out.</p>`,
      },
      {
        image: DesignSmartSlide05,
        content: `<p class="h3">Custom Exterior Features</p><p>Your home takes on a whole new dimension when you add a modern deck, cozy porch or spacious garage to the plans. Choose from a variety of customizable exterior features, including detached garages.</p>`,
      },
    ],
  },
  {
    headline: 'Comfort and energy savings, redefined.',
    color: '#00B0AC',
    logo: EnergySmartLogo,
    id: 'EnergySmart',
    slides: [
      {
        image: EnergySmartSlide01,
        videoID: 'bm5txmjioe',
        fobVideoID: 'ezikht6ick',
        gaClass: 'ga-housesmart-video-energysmart',
        retailEventLabel: 'housesmart_energysmart_video',
        content: `<p class="h3">Our EnergySmart Zero™ energy ready homes are so energy efficient that a renewable energy system can offset most, if not all, of their annual energy use. Enjoy a whole new level of home performance in energy savings, comfort, health and durability.</p>
          <a
            href='/energysmart'
            class="link-btn"
          >
            TOUR HOME FEATURES
          </a>`,
      },
      {
        image: EnergySmartSlide02,
        content: `
          <p class="h3">Brands You Can Trust</p><p>Saving money on energy costs doesn’t mean cutting corners when it comes to the trusted products in your home. You can find these industry leading brands in every EnergySmart Zero™ home:</p>
          <ul>
            <li>ecobee Smart Thermostat®</li>
            <li>Rheem® hybrid electric heat pump water heater</li>
            <li>Lux® argon gas Low-E windows</li>
            <li>Carrier SmartComfort® heat pump HVAC units</li>
            <li>ENERGY STAR®* certified Samsung® and Frigidaire® appliances</li>
          </ul>
          <p class="sub-note">*ENERGY STAR and the ENERGY STAR mark are registered trademarks owned by the U.S. Environmental Protection Agency.</p>
          `,
      },
      {
        image: EnergySmartSlide03,
        content: `
          <p class="h3">Insulation Matters</p>
          <p>The next-gen Johns Manville ® or Knaut ® insulation in our EnergySmart Zero™ homes will keep you comfortable during any season, including:</p>
          <ul>
            <li>A thick blanket of R22 insulation in the floors</li>
            <li>R13 insulation in the walls*</li>
            <li>Blown-in R38 insulation in the roof cavity</li>
          </ul>
          <p class="sub-note">*Thermal Zone 3 homes will have R21 wall insulation with 2” x 6” exterior wall studs with R27 insulation in the sub-floor.</p>
          `,
      },
      {
        image: EnergySmartSlide04,
        content: `
        <p class="h3">Air-Tight Construction</p>
        <p>Sealed ductwork ensures hot or cool air gets where it needs to go in your home, without expensive leaks, while ThermoPly structural sheathing provides durability, moisture resistance and a best-in-class air barrier.</p>`,
      },
      {
        image: EnergySmartSlide05,
        content: `
          <p class="h3">DOE Zero Energy Ready Home™ Certified</p>
          <p>Our homes are 40-50% more efficient than an average home, saving you tens of thousands* over the life of your home. Enjoy a whole new level of comfort and energy savings with EnergySmart Zero™.</p>
          <ul>
            <li>Built to the U.S. Department of Energy’s high efficiency specification</li>
            <li>Our most insulated homes ever</li>
            <li><a class="page-link" href='/energysmart'>Learn more here.</a></li>
          </ul>
          <p class="sub-note">*EnergySmart Zero™ homes are built with energy efficient features and made to DOE Zero Energy Ready Home™ program specifications. <a  class="page-link" href="https://stage.energy.gov/eere/buildings/articles/ultra-efficient-fact-sheet" target="_blank">Source</a></p>
          `,
      },
    ],
  },
  {
    headline: 'Homeownership that’s within reach.',
    color: '#FFC50A',
    logo: BudgetSmartLogo,
    textColor: '#25292D',
    id: 'BudgetSmart',
    slides: [
      {
        image: BudgetSmartSlide01,
        videoID: 'y7zamz6gbt',
        fobVideoID: '4czre8mn59',
        gaClass: 'ga-housesmart-video-budgetsmart',
        retailEventLabel: 'housesmart_budgetsmart_video',
        content: `<p class="h3">A Clayton Built® home is an investment in your future that can save you money and open doors to a better life.</p>`,
      },
      {
        image: BudgetSmartSlide02,
        content: `<p class="h3">Less Waste, More Savings</p><p>Our homes are built inside cutting-edge, climate controlled facilities for a faster, more precise process.  We avoid costly delays and needless waste, helping you save at every turn.</p>`,
      },
      {
        image: BudgetSmartSlide03,
        content: `<p class="h3">More for Your Money</p><p>Get the luxury, quality and style you want in a beautiful, affordable home with energy-efficient features that fits any budget.</p>`,
      },
      {
        image: BudgetSmartSlide04,
        content: `<p class="h3">A Lifetime of Savings</p>
        <p>Our EnergySmart Zero™ homes are built with energy efficient features that can save you tens of thousands of dollars over time*.</p>
        <p><a  class="page-link" href="https://stage.energy.gov/eere/buildings/articles/ultra-efficient-fact-sheet" target="_blank">*Source</a><p>`,
      },
    ],
  },
];

export default houseSmartPillarContent;
